<template>
  <div class="battery-mgmt">
    <div class="main-title">
      <p>服务资源管理</p>
    </div>
    <div class="main-body">
      <el-form size="mini" :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-button class="w150" type="primary" @click="handleAdd('1')"
            >新增服务资源分组</el-button
          >
          <el-button class="w100" type="primary" @click="handleAdd('2')"
            >新增服务资源</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        :data="recordList"
        style="width: 100%;margin-bottom: 20px;"
        cell-class-name="text-center"
        row-key="number"
        :tree-props="{ children: 'serviceResourceList', hasChildren: 'true' }"
        v-loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column prop="number" label="编号"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="path" label="路径"></el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)" type="text" size="mini"
              >编辑</el-button
            >
            <el-button @click="handleDelete(scope.row)" type="text" size="mini"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      :title="
        (opearteType == '1' ? '新增' : '编辑') +
          (objectType == '1' ? '服务资源分组' : '服务资源')
      "
      :visible.sync="dialogTableVisible"
      width="500px"
      :show-close="false"
    >
      <el-form ref="form" :model="editRecord" label-width="80px">
        <el-form-item label="资源分组" v-if="objectType == '2'">
          <el-select v-model="editRecord.groupNo" placeholder="请选择">
            <el-option
              v-for="item in recordList"
              :key="item.number"
              :label="item.name"
              :value="item.number"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称">
          <el-input
            v-model="editRecord.name"
            placeholder="请输入名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="路径" v-if="objectType == '2'">
          <el-input
            v-model="editRecord.path"
            placeholder="请输入路径"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">确定</el-button>
          <el-button @click="closeDialog">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Utils from "../utils/utils";
export default {
  name: "serviceResourceMgmt",
  data() {
    return {
      token: Utils.getLocalStorage("token"),
      recordList: [],
      dialogTableVisible: false,
      opearteType: "",
      objectType: "",
      parentMenuNo: "",
      editRecord: {},
      loading: false,
      loadingText: "数据加载中...",
    };
  },
  mounted() {
    this.queryRecordList();
  },
  methods: {
    queryRecordList() {
      let self = this;
      self.loading = true;
      self.loadingText = "数据加载中...";
      this.$http
        .get("/admin/serviceResource/group/findAll?findChildren=true", {
          headers: { token: this.token },
        })
        .then(function(response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "查询失败!");
            return;
          }
          self.recordList = res.ldata;
        })
        .catch(function(response) {
          self.loading = false;
        });
    },

    handleAdd: function(type) {
      this.editRecord = {};
      this.opearteType = "1";
      this.objectType = type;
      this.dialogTableVisible = true;
    },

    onSubmit: function() {
      this.createOrUpdate();
    },

    createOrUpdate: function() {
      let self = this;
      self.loading = true;
      self.loadingText = "数据处理中...";
      let url =
        "/admin/serviceResource" +
        (self.objectType == "1" ? "/group" : "") +
        "/createOrUpdate?" +
        this.$qs.stringify(self.editRecord);

      this.$http
        .get(url, {
          headers: { token: this.token },
        })
        .then(function(response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "操作失败!");
            return;
          }
          self.$message({
            type: "success",
            message: "操作成功",
            center: true,
          });
          self.closeDialog();
          self.queryRecordList();
        })
        .catch(function(response) {
          self.loading = false;
        });
    },

    closeDialog: function() {
      this.dialogTableVisible = false;
      this.item = {};
    },
    handleEdit: function(row) {
      this.opearteType = "2";
      this.dialogTableVisible = true;
      this.editRecord = JSON.parse(JSON.stringify(row));
      this.objectType = this.editRecord.groupNo === undefined ? "1" : "2";
    },

    handleDelete(item) {
      this.objectType = item.groupNo === undefined ? "1" : "2";
      this.$confirm("是否确认删除？").then(() => {
        this.delete(item.number);
      });
    },

    delete(number) {
      let self = this;
      let params = {
        number: number,
      };
      let url =
        "/admin/serviceResource" +
        (self.objectType == "1" ? "/group" : "") +
        "/delete?" +
        this.$qs.stringify(params);
      self.loading = true;
      self.loadingText = "数据处理中...";
      this.$http
        .get(url, {
          headers: { token: this.token },
        })
        .then(function(response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "操作失败!");
            return;
          }
          self.$message({
            type: "success",
            message: "操作成功",
            center: true,
          });
          self.queryRecordList();
        })
        .catch(function(response) {
          self.loading = false;
        });
    },

    handleQuery() {
      this.queryRecordList();
    },
    showErrorMessage(message) {
      if (message == "0000") {
        this.$message({
          type: "warning",
          message: "请先登录",
          center: true,
        });
      } else if (message == "0001") {
        this.$message({
          type: "warning",
          message: "未认证",
          center: true,
        });
      } else if (message == "0002") {
        this.$message({
          type: "warning",
          message: "无权限",
          center: true,
        });
      } else {
        this.$message({
          type: "error",
          message: message,
          center: true,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-body {
  .list {
    line-height: 30px;
    margin: 20px 30px 10px;

    .name-label {
      float: left;
    }

    .value-label {
      display: inline-block;
      height: 30px;
    }

    .date-global {
      width: 185px;
    }

    .list-input {
      width: 180px;
    }

    .fixed-width-100 {
      width: 100px;
    }

    .fixed-width-200 {
      width: 200px;
    }

    .fixed-width-300 {
      width: 300px;
    }

    .fixed-width-400 {
      width: 400px;
    }
  }

  .table-custom {
    border-bottom: 1px solid #cdcdcd;
    .text-btn {
      width: 50px;
      height: 24px;
      line-height: 24px;
      color: #4949ff;
      display: inline-block;
      background-color: #67aff6;
      cursor: pointer;
    }

    .text-btn.disabled {
      border: #67aff6;
      background-color: #fff;
      cursor: default;
    }

    .fixed-width-75 {
      width: 75px;
    }

    .fixed-width-100 {
      width: 100px;
    }

    .fixed-width-300 {
      width: 300px;
    }

    .mt4 {
      margin-top: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/serviceResourceMgmt.vue